import { createStore } from 'redux'
import { combineReducers } from 'redux'
import quiz from '../reducers/quiz-reducer'

const reducers = combineReducers({
    quiz
});

const store = createStore(
    reducers,
    (typeof window !== "undefined") ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : {}
);

export default store
